import get from 'lodash/get';
import {
  UPLOAD_EQUIPMENT_FILE,
  UPLOAD_EQUIPMENT_FILE_FAILURE,
  UPLOAD_EQUIPMENT_FILE_SUCCESS,
  COPY_CHECKS,
  COPY_CHECKS_SUCCESS,
  COPY_CHECKS_FAILURE,
} from './types';

const initialState = {
  isUploadLoading: false,
  isChecksCopying: false,
  error: null,
};

const uploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_EQUIPMENT_FILE: {
      return {
        ...state,
        isUploadLoading: true,
        error: null,
      };
    }

    case UPLOAD_EQUIPMENT_FILE_SUCCESS: {
      const resData = get(action, 'response', []);
      return {
        ...state,
        // rentalGroupList: resData.rows,
        uploadResponse: '',
        isUploadLoading: false,
        error: null,
      };
    }

    case UPLOAD_EQUIPMENT_FILE_FAILURE: {
      return {
        ...state,
        isUploadLoading: false,
        error: action.payload,
      };
    }

    case COPY_CHECKS: {
      return {
        ...state,
        isChecksCopying: true,
        error: null,
      };
    }

    case COPY_CHECKS_SUCCESS: {
      return {
        ...state,
        isChecksCopying: false,
        error: null,
      };
    }

    case COPY_CHECKS_FAILURE: {
      return {
        ...state,
        isChecksCopying: false,
        error: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default uploadReducer;
